import { Field, Form, Formik } from 'formik'
import React from 'react'
import Modal from 'react-bootstrap/Modal'
import { Schema } from './utilities'
import useSetEmail from './hooks/useSetEmail'
interface IModalProps {
    show: boolean
    onHide: () => void
    moneyPool: string | undefined
    fullReport: number
}
export default function DownloadExcelEmailModal({
    show,
    onHide,
    moneyPool,
    fullReport,
}: IModalProps) {
    const profile = JSON.parse(localStorage.getItem('profile')!)
    const { mutate } = useSetEmail(onHide)
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full text-center py-4 text-xs">
                <p className=" mb-3">
                    ایمیلی که تمایل دارید گزارش به آن ارسال شود را وارد کنید
                </p>
                <p className=" text-gray-4 mb-2">{`[گزارشات قابل درخواست در این دوره ${fullReport} عدد]`}</p>
                <Formik
                    initialValues={{
                        email: profile && profile?.email ? profile.email : '',
                    }}
                    validationSchema={Schema}
                    onSubmit={async (values) => {
                        const payload: IFacilitiesReportExcelEmail = {
                            moneyPool: moneyPool,
                            email: values.email,
                        }
                        mutate(payload)
                    }}
                >
                    {({
                        submitForm,
                        values,
                        handleChange,
                        errors,
                        touched,
                    }) => (
                        <Form className=" mx-4">
                            <Field
                                type="email"
                                name="email"
                                className=" w-full outline-0 text-center  border border-gray-1 py-3 rounded-md"
                            />
                            {errors.email && touched.email && (
                                <p className=" text-sm text-error-3 text-center">
                                    ایمیل درست وارد کنید
                                </p>
                            )}
                            <div className=" w-full flex justify-between mt-4 ">
                                <button
                                    type="submit"
                                    className=" w-full rounded-md text-white bg-green-1 text-center py-3 mx-1"
                                >
                                    تایید
                                </button>
                                <button
                                    type="button"
                                    className=" w-full rounded-md  bg-white text-center border border-gray-4 py-3 mx-1"
                                    onClick={onHide}
                                >
                                    بازگشت
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </Modal>
    )
}
